import styled from "styled-components";

const StatusLineWrapper = styled.div`
  background: ${({ theme }) => theme.colors.baseWhite};
  border-radius: 8px;
  padding: 4px 8px;
`;

export default StatusLineWrapper;
